import * as React from 'react';
import './Well.scss';
import classNames from 'classnames';

export type WellProps = Pick<React.HTMLAttributes<HTMLDivElement>, 'className' | 'style'> & {
    children?: React.ReactNode;
    title?: string;
    toolbar?: React.ReactNode;
};

export const Well: React.FunctionComponent<WellProps> = React.memo(
    ({ children, className, title, toolbar, ...rest }) => (
        <div className={classNames('well', className)} {...rest}>
            {(title || toolbar) && (
                <div className="well__header">
                    <h3 className="well__header__title">{title}</h3>
                    {toolbar && <div className="well__header__toolbar-wrapper">{toolbar}</div>}
                </div>
            )}
            {children}
        </div>
    ),
);
Well.displayName = 'Well';
